import React, { useState } from 'react';

import CommonTabs, { TABS_APPEARANCE } from '../../../components/common-tabs/CommonTabs';
import CommonTabPanel from '../../../components/common-tabs/CommonTabPanel';
import { MEDIA_STUDIO_SETTINGS_TABS } from '../../../constants';
import BrandColors from './components/brand-colors/BrandColors';
import FontAssets from './components/font-assets/FontAssets';
import ImageAssets from './components/image-assets/ImageAssets';
import useMediaTabs from './hooks/useMediaTabs';

import scss from './MediaStudioSettings.module.scss';

function MediaStudioSettings() {
  const [selectedTab, setSelectedTab] = useState(MEDIA_STUDIO_SETTINGS_TABS.IMAGES);

  const tabs = useMediaTabs();

  const handleChangeTab = (_, tab) => {
    setSelectedTab(tab);
  };

  return (
    <div className={scss.root}>
      <CommonTabs
        tabs={tabs}
        value={selectedTab}
        onChange={handleChangeTab}
        isContainerFullWidth={false}
        appearance={TABS_APPEARANCE.FILLED}
      />

      <CommonTabPanel value={selectedTab} index={MEDIA_STUDIO_SETTINGS_TABS.IMAGES} className={scss.tabPanel}>
        <ImageAssets />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={MEDIA_STUDIO_SETTINGS_TABS.FONTS} className={scss.tabPanel}>
        <FontAssets />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={MEDIA_STUDIO_SETTINGS_TABS.COLORS} className={scss.tabPanel}>
        <BrandColors />
      </CommonTabPanel>
    </div>
  );
}

export default MediaStudioSettings;
